module.exports = __webpack_public_path__ + "img/Tony_G_Circle.bb42b487.png";